import React, {PureComponent} from 'react';
import cn from 'classnames'
import {connect} from 'react-redux'
import injectSheet, {withTheme} from 'react-jss'
import throttle from 'lodash/throttle'
import {
    getGlobalContent, getCurrentLocation, getSelectedGenderLabel,
    isShopTheLookOpen, getUniversalMobileMenuIsOpen
} from '../../selectors'
import {selectGender, CONTENT_ROUTE, toggleMobileMenu, closeDropdown} from '../../actions'
import {genderEmpty} from "../../utils/gender"
import {canUseDom} from "../../utils/dom";
import {getScrollBarWidth} from "../../utils/measure";
import {TweenLite} from 'gsap'
import EditionMobileNav from './EditionMobileNav'
import hamburger from '../../img/hamburger.svg'
import close from '../../img/close.svg'
import NavItem from "./NavItem"
import SearchIcon from './SearchIcon'
import Section from '../Widgets/Section'

let scrollListener;
const PAGE_OFFSET = 280
const HEIGHT = 56;

class EditionNav extends PureComponent {

    componentDidMount() {
        scrollListener = throttle(this._handleScrollChanged, 20);
        window.addEventListener('scroll', scrollListener);
    }

    componentWillUnmount() {
        if(!scrollListener) return;
        window.removeEventListener('scroll', scrollListener);
        scrollListener = null;
    }

    _handleScrollChanged = () => {
        const { handleNavIn } = this.props
        if(!this._ref ) return;

        if(window.pageYOffset <= (PAGE_OFFSET + (this.in ? -20 : 0))) {
            if(!this.in) {
              this.in = true;
              TweenLite.to(this._ref, 0.35, {y: -80, onComplete: () => {
                TweenLite.set(this._ref, {opacity: 0});
              }});
              handleNavIn()
            }
        }
        else {
          if(this.in) {
            this.in = false;
            TweenLite.set(this._ref, {opacity: 1});
            TweenLite.to(this._ref, 0.35, {y: 0});
          }
        }
    }

    _onGenderChanged = (selected_gender) => {
        const {handleGenderChanged, gender, location} = this.props;
        if (selected_gender === gender) {
          handleGenderChanged(null, location)
        } else {
          handleGenderChanged(selected_gender, location)
        }
    }

    _setRef = (ref) => this._ref = ref;

    _getUrlWithGender = (url, gender) => {
        if(!gender || gender === genderEmpty) return url;
        return url + "?g=" + gender;
    }

    _isMenuSelected = (menu) => {
        const {location} = this.props;
        return location.pathname === menu.url;
    }

    _toggleMobileMenu = () => {
        const { toggleMobileMenu } = this.props;
        toggleMobileMenu()
    }

    render() {
        const {classes, global, dialogOpen, mobileMenuOpen} = this.props;
        const hide = !canUseDom || window.pageYOffset <= PAGE_OFFSET

        if(!global) return null;
        return (<header className={cn(classes.header, {hide})} ref={this._setRef} style={{right: dialogOpen ? getScrollBarWidth() : 0}}>
            <Section className={cn(classes.headerRow)}>
                <div className={classes.spacer}></div>
                <SearchIcon classNames={{ searchLink: classes.searchLink }} />
                <div className={classes.shopButtonContainer}>
                    <ul>
                        <NavItem
                            label='SHOP THE ICONIC'
                            url="https://www.theiconic.com.au/"
                        />
                    </ul>
                </div>
                <div className={classes.mobileMenuToggle}>
                    <button className={classes.mobileMenuButton} onClick={this._toggleMobileMenu}>
                        { mobileMenuOpen ? (
                            <img src={close} alt="Logo"/>
                        ) : (
                            <img src={hamburger} alt="Logo"/>
                        )}
                    </button>
                </div>
            </Section>
            <EditionMobileNav />
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        global: getGlobalContent(state),
        genderLabel: getSelectedGenderLabel(state),
        location: getCurrentLocation(state),
        dialogOpen: isShopTheLookOpen(state),
        mobileMenuOpen: getUniversalMobileMenuIsOpen(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleGenderChanged: (gender, location) => {
            dispatch(selectGender(gender));
            dispatch( { type: CONTENT_ROUTE, payload: [ location.pathname ], query: { g: gender !== genderEmpty ? gender : undefined} } );
        },
        toggleMobileMenu: () => dispatch(toggleMobileMenu()),
        handleNavIn: () => dispatch(closeDropdown('gender'))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( injectSheet(theme => (
    {
        header: {
            height: HEIGHT,
            zIndex: theme.zIndex.menu - 1,
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: theme.colors.white,
            color: theme.header.textColor,
            transform: 'translate(0, -80px)',
            borderBottom: [1, 'solid', theme.colors.border]
        },
        headerRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: '100%'
        },
        mainNavContainer: {
            display: "none",
            [theme.breakpoint("tablet")]: {
                display: "block",
                textAlign: 'center',
                height: '100%',
                flexGrow: 1,
            }
        },
        mainNav: {
            minWidth: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: 'space-between',
            [theme.breakpoint("tablet")]: {
                justifyContent: 'flex-end',
            },
        },
        logo: {
            height: 31,
            [theme.breakpoint("tablet")]: {
                margin: `0 ${theme.spacing.tiny} 0 0`,
                height: 36,
            },
        },
        spacer: {
            width: 200,
            flex: 1
        },
        menuButtonContainer: {
            display: 'none',
            alignItems: "center",
            width: 100,
            height: '100%',
            justifyContent: 'flex-end',
            [theme.breakpoint("tablet")]: {
                display: "flex",
            },
        },
        genderFilter: {
            display: "flex",
            marginRight: 10,
            minHeight: 56,
            color: theme.colors.black,
            ...theme.font.menu.normal,
            textDecoration: "none",
            transition: 'color 0.3s ease',
            textAlign: 'left',
            fontSize: theme.getRemValue(13),
            ...theme.font.familyBoldStyle,
            letterSpacing: 0.26,
            [theme.breakpoint("tablet")]: {
              color: 'rgba(70, 70, 70, 1)',
            },
            "&:hover": {
              [theme.breakpoint("tablet")]: {
                color: theme.colors.primary
              }
            }
        },
        genderFilterDropDown: {
            backgroundColor: theme.colors.white,
            color: theme.colors.black,
            boxShadow: '0px 5px 10px rgba(0,0,0,0.1)',
            top: '100%',
            left: -22,
            minWidth: 120,
            textAlign: 'left',
            fontSize: theme.getRemValue(14),
            fontWeight: 300,
            cursor: 'initial',
            "& li": {
                margin: 0,
                '&:first-child a': {
                    marginTop: 10
                },
                '&:last-child a': {
                    marginBottom: 10
                }
            },
            "& a": {
                color: theme.colors.black,
                fontFamily: theme.font.family,
                fontSize: theme.getRemValue(14),
                fontWeight: 300,
                padding: [0, 24, 0, 42],
                height: 32,
                lineHeight: '32px',
                display: 'block',
                width: '100%',
                position: 'relative',
                '&:hover': {
                    textDecoration: 'none',
                    '&:before, &:after': {
                        borderColor: theme.colors.primary
                    }
                },
                '&.selected': {
                    color: theme.colors.primary
                },
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    top: 10,
                    left: 28,
                    width: 1,
                    height: 10,
                    border: ['solid', theme.colors.black],
                    borderWidth: '0px 1px 1px 0px',
                    transform: 'rotate(90deg)',
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: 10,
                    left: 28,
                    width: 1,
                    height: 10,
                    border: ['solid', theme.colors.black],
                    borderWidth: '0px 1px 1px 0px',
                },
                '&.selected:before': {
                    display: 'none'
                },
                '&.selected:after': {
                    display: 'block',
                    transform: 'rotate(45deg)',
                    width: 6,
                    top: 8,
                    right: 5,
                    borderColor: theme.colors.primary,
                }
            },
        },
        genderFilterTitle: {
            textAlign: 'left',
            textTransform: 'none',
            padding: `18px 24px 8px`,
            ...theme.font.familyBoldStyle,
        },
        shopButtonContainer: {
            display:'none',
            [theme.breakpoint("laptop")]: {
                display:'block',
                '& ul': {
                    margin: [0, 0, 0, 18],
                    padding: [0],
                    position: 'relative',
                    "&:before": {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        width: 1,
                        height: 32,
                        borderLeft: `1px solid #B0B0B0`,
                        top: 12,
                        zIndex: 99
                    },
                    '& a': {
                        color: 'rgba(70, 70, 70, 1)',
                        whiteSpace: 'nowrap',
                        opacity: 1,
                        padding: [0, 0, 0, 32],
                        '&:hover': {
                            textDecoration: 'none',
                            color: theme.colors.primary
                        }
                    }
                }
            }
        },
        searchLink: {
            display: 'none',
            '&:hover': {
                color: theme.colors.primary
            },
            [theme.breakpoint('tablet')]: {
                display: 'block',
                marginLeft: 15
            },
        },
        mobileMenuToggle: {
            display: 'block',
            [theme.breakpoint("tablet")]: {
                display: 'none'
            }
        },
        mobileNav: {
            display: 'block',
            [theme.breakpoint("tablet")]: {
                display: 'none'
            }
        },
        mobileMenuButton: {
            display: 'flex',
            background: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            outline: 'none',
            padding: [2, 10, 0],
            '& > img': {
                width: 16
            }
        }
    })
)(withTheme(EditionNav)) );



// WEBPACK FOOTER //
// ./src/components/UniversalNav/EditionNav.js